module.exports = __webpack_public_path__ + "img/header.c18c69d4.jpg";